/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { documentsPatchMetadata } from "../../funcs/documentsPatchMetadata.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.PatchDocumentMetadataRequest$inboundSchema,
};

export const tool$documentsPatchMetadata: ToolDefinition<typeof args> = {
  name: "documents-patch-metadata",
  description: `Patch Document Metadata`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await documentsPatchMetadata(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
